// CommonSliderCard.js
import React, { useState, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import { DropdownContentNew, Layout, OuterContainer} from '../../components/UserDashboard/styles'
import { SliderLeftArrowIcon, SliderRightArrowIcon } from "../../utils/icons";
import { ImageUrl } from "../../utils/constants";
import PropTypes from "prop-types";
import SkeletonLoder from "../../components/common/skeletonLoder";


const CommonSliderCard = ({ data = [], title, type, loading }) => {
  const history = useHistory();
  const scrollRef = useRef(null);
  const wrapperRef = useRef(null);

  const [isStart, setIsStart] = useState(true);
  const [isEnd, setIsEnd] = useState(false);
  const [isHover, setIsHover] = useState(false);

  const checkScrollPosition = () => {
    const el = scrollRef.current;
    if (!el) return;

    const scrollLeft = Math.ceil(el.scrollLeft);
    const maxScrollLeft = el.scrollWidth - el.clientWidth;

    setIsStart(scrollLeft <= 0);
    setIsEnd(scrollLeft >= maxScrollLeft - 1);
  };

  const scroll = (direction) => {
    const el = scrollRef.current;
    if (!el) return;
    const scrollAmount = 280;

    el.scrollBy({
      left: direction === "left" ? -scrollAmount : scrollAmount,
      behavior: "smooth"
    });
  };

  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;

    checkScrollPosition();

    el.addEventListener("scroll", checkScrollPosition);
    window.addEventListener("resize", checkScrollPosition);

    return () => {
      el.removeEventListener("scroll", checkScrollPosition);
      window.removeEventListener("resize", checkScrollPosition);
    };
  }, [data]);

  if (loading || !data || data.length === 0) {
    return (
      <OuterContainer isOuterpadding="0 20px 16px 20px">
        <Layout margin="20px 0 0 0" padding="0px">
          <div className="headingMain">
            <div className="heading">{title}</div>
          </div>
          <div style={{ marginTop: "16px" }}>
            <SkeletonLoder height="40px" width="100%" />
          </div>
        </Layout>
      </OuterContainer>
    );
  }

  return (
    <OuterContainer isOuterpadding="0 20px 16px 20px">
      <Layout margin="20px 0 0 0" padding="0px">
        <div className="headingMain">
          <div className="heading">{title}</div>
        </div>

        <div
          ref={wrapperRef}
          onMouseEnter={() => setIsHover(true)}
          onMouseLeave={() => setIsHover(false)}
          style={{
            position: "relative",
            marginTop: "16px",
            paddingLeft: isHover && !isStart ? "40px" : "10px",
            paddingRight: isHover && !isEnd ? "40px" : "10px",
            transition: "padding 0.2s ease"
          }}
        >
          {/* LEFT ARROW */}
          {isHover && !isStart && scrollRef.current?.scrollWidth > scrollRef.current?.clientWidth && (
            <div
              style={{
                position: "absolute",
                left: "10px",
                top: "40%",
                transform: "translateY(-50%)",
                cursor: "pointer",
                zIndex: 3,
                transition: "opacity 0.2s ease"
              }}
              onClick={() => scroll("left")}
            >
              <SliderLeftArrowIcon />
            </div>
          )}

          {/* RIGHT ARROW */}
          {isHover && !isEnd && scrollRef.current?.scrollWidth > scrollRef.current?.clientWidth && (
            <div
              style={{
                position: "absolute",
                right: "10px",
                top: "40%",
                transform: "translateY(-50%)",
                cursor: "pointer",
                zIndex: 3,
                transition: "opacity 0.2s ease"
              }}
              onClick={() => scroll("right")}
            >
              <SliderRightArrowIcon />
            </div>
          )}

          {/* SCROLL AREA */}
          <div style={{ position: "relative" }}>
            <div
              ref={scrollRef}
              onScroll={checkScrollPosition}
              style={{
                display: "flex",
                overflowX: "auto",
                scrollBehavior: "smooth",
                gap: "12px",
                paddingBottom: "4px"
              }}
            >
              {data.map((item) => (
                <DropdownContentNew
                  key={item.id}
                  style={{ flex: "0 0 auto" }}
                  onClick={() =>
                    history.push({
                      pathname: `/wellness-resources/${type}`,
                      state: { categoryData: item, type }
                    })
                  }
                >
                  <img
                    src={`${ImageUrl}/${item.image}`}
                    className="category-img"
                    alt={item.category_name}
                  />
                  <div className="listContent">{item.category_name}</div>
                </DropdownContentNew>
              ))}
            </div>

            {/* RIGHT FADE EFFECT */}
            {!isEnd && (
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  right: 0,
                  height: "100%",
                  width: "90px",
                  pointerEvents: "none",
                  background: "linear-gradient(to right, rgba(255,255,255,0), #ffffff)"
                }}
              />
            )}
          </div>
        </div>
      </Layout>
    </OuterContainer>
  );
};


CommonSliderCard.propTypes = {
  loading:PropTypes.bool,
  data: PropTypes.array,
  type: PropTypes.string,
  title: PropTypes.string,
  currentSlide:PropTypes.number,
  setCurrentSlide:PropTypes.func,
  className:PropTypes.string,
  onClick:PropTypes.func,
  style:PropTypes.object,
};

export default CommonSliderCard;